import { useSelector } from 'react-redux';

import type { RootState } from '../../../../store';

export default function useIntakeEducationInfoUpdateLoading() {
  return useSelector(
    (state: RootState) => state.intakeQuestionnaire.updateEducationInfoLoading,
  );
}
